import React from 'react';

import { routeToSpecificScope } from '../../../../helpers';
import { SimpleMultiSelectorPresentational } from '../SimpleMultiSelector';
import { FILTER_KEYS } from '../../../../config/constants';
import { ParamWrapper } from '../ParamWrapper';
import { useFiltersState } from '../../../../store/hooks';
import {
  PositionLacrosseFilterPropsType,
  PositionLacrosseFilterWrappedPropsType
} from './types';
import { useRouter } from '../../../../helpers/customHooks';

const PositionLacrosseFilterWrapped = ({
                                         forceScope,
                                         changeFilterDataWrapped,
                                         ...restProps
                                       }: PositionLacrosseFilterWrappedPropsType) => {
  
  const { pathname } = useRouter();
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const { [FILTER_KEYS.POSITIONS]: currentFilter = [] } = useFiltersState(specificScope, FILTER_KEYS.POSITIONS);
  
  return (
    <SimpleMultiSelectorPresentational
      {...restProps}
      forceScope={forceScope}
      filterData={currentFilter}
      changeFilterData={(positions) => changeFilterDataWrapped(positions)()}
    />
  );
};

const PositionLacrosseFilter = (props: PositionLacrosseFilterPropsType) => {
  return (
    <ParamWrapper
      fromUrlSearchParam={() => []}
      toUrlSearchParam={() => ''}
      Component={PositionLacrosseFilterWrapped}
      props={props}
      filterKey={FILTER_KEYS.POSITIONS}
    />
  );
};

export default PositionLacrosseFilter;